module.exports = __webpack_public_path__ + "img/from-strategies-icon.85630108.svg";